



























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SavedFilter } from '@/models/SavedFilter';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';

@Component
export default class FilterSaveDialog extends Vue {

    public showDialog: boolean = false;
    public showDrawToolbar: boolean = false;

    public drawPolygon: any = null; // as L.Draw.Polygon
    public spatialFilterLayer: L.GeoJSON | null = null;
    public spatialFilterStyle = {
        color: '#DC1C2E',
        fillColor: '#DC1C2E',
        weight: 4,
        opacity: 1,
        fillOpacity: 0.15,
    };

    public resultsSaved: boolean = false;
    public filterName: string = '';
    public showNotifications: boolean = false;
    public notificationAreaType: string = 'extent';

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showFilterSaveDialog') {
            this.onShowDialog();
        }
        if (action.type === 'saveFilterSuccess') {
            this.onResultSaved();
        }
    });

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    get activeSpatialFilter() {
        return this.$store.state.filters.spatialFilter;
    }

    public onShowDialog() {
        this.filterName = '';
        this.showNotifications = false;
        this.resultsSaved = false;
        this.notificationAreaType = 'extent';
        this.showDialog = true;
    }

    public onSaveFilter() {
        let payload: any = {
            Notifications: this.showNotifications,
            Name: this.filterName,
        };

        if (this.showNotifications) {
            if (this.notificationAreaType === 'extent') {
                const extent = L.rectangle(this.map.getBounds()).toGeoJSON();
                payload = {
                    Notifications: this.showNotifications,
                    Name: this.filterName,
                    SpatialFilter: extent,
                };
            } else if (this.notificationAreaType === 'school') {
                payload = {
                    Notifications: this.showNotifications,
                    Name: this.filterName,
                    SpatialFilter: this.activeSpatialFilter.toGeoJSON(),
                };
            } else if (this.spatialFilterLayer) {
                payload = {
                    Notifications: this.showNotifications,
                    Name: this.filterName,
                    SpatialFilter: this.spatialFilterLayer.toGeoJSON(),
                };
            }
        }
        this.$store.dispatch('saveActiveFilter', payload);
    }

    public onResultSaved() {
        this.resultsSaved = true;
    }

    public onDrawArea(input: string) {
        console.log('FilterSaveDialog: onDrawArea()');
        this.showDialog = false;
        this.showDrawToolbar = true;

        // @ts-ignore - no typedefs
        L.drawLocal.draw.handlers.polygon.tooltip.start = 'Click to start drawing filter area';
        // @ts-ignore - no typedefs
        L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Click to continue drawing filter area.';
        // @ts-ignore - no typedefs
        L.drawLocal.draw.handlers.polygon.tooltip.end = 'Click first point to finish.';

        const drawOptions = {
            position: 'topleft',
            draw: {
                polygon: {
                    allowIntersection: false,
                    drawError: {
                        color: '#ffa500',
                        message: '<strong>Opps...sorry!<strong> you can\'t draw that!',
                    },
                    shapeOptions: {
                        color: '#0043ff',
                        opacity: 1.0,
                        weight: 6,
                        fillColor: '#ff1200',
                        fillOpacity: 0.4,
                    },
                },
                polyline: false,
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false,
            },
        };

        // @ts-ignore - no typedefs
        this.drawPolygon = new L.Draw.Polygon(this.map, {
            allowIntersection: false,
            drawError: {
                color: '#ffa500',
                message: '<strong>Opps...sorry!<strong> you can\'t draw that!',
            },
            shapeOptions: {
                color: '#0043ff',
                opacity: 1.0,
                weight: 6,
                fillColor: '#ff1200',
                fillOpacity: 0.4,
            },
        });
        this.drawPolygon.enable();

        // @ts-ignore - no typedefs
        this.map.on(L.Draw.Event.CREATED, (e) => {
            // console.log('CREATED');
            // drawstop gets fired when created so disable it!
            this.map.off('draw:drawstop');

            this.spatialFilterLayer = L.geoJSON(e.layer.toGeoJSON(),
                {
                    style: this.spatialFilterStyle,
                    pane: 'vector',
                });

            this.map.removeLayer(e.layer);
            this.spatialFilterLayer.addTo(this.map);

            // give it 1 sec to show the final shape drawn
            setTimeout(() => {
                this.onCancelDraw();
            }, 1000);

        });

        // @ts-ignore - no typedefs
        this.map.on('draw:drawstop', (e) => {
            console.log('CANCEL');
            this.onCancelDraw();
        });
    }

    public onCancelDraw() {
        console.log('FilterDialog: onCancelDraw()');
        if (this.drawPolygon) {
            // @ts-ignore
            this.map.off(L.Draw.Event.CREATED);
            this.map.off('draw:drawstop');

            this.drawPolygon.disable();
            this.drawPolygon = null;
        }
        this.showDialog = true;
        this.showDrawToolbar = false;
    }

    public onHide() {
        if (this.spatialFilterLayer) {
            this.spatialFilterLayer.removeFrom(this.map);
        }
    }

}

